import { Link } from "react-router";
import { useTranslation } from "react-i18next";

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center gap-4 py-24">
      <p className="text-8xl font-black text-gray-200">404</p>
      <h1 className="text-2xl font-bold text-gray-800">
        {t("errors.notFound")}
      </h1>
      <p className="text-sm text-gray-500">{t("errors.notFoundSubtitle")}</p>
      <Link
        to="/dashboard"
        className="mt-2 rounded-xl bg-brand-primary px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-brand-primary-hover"
      >
        {t("errors.goToDashboard")}
      </Link>
    </div>
  );
}
